import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { MenuItem, Select, FormControl } from '@mui/material';
import { LanguageContext } from '../contexts/LanguageContext';
var LanguageSelector = function () {
    var _a = useContext(LanguageContext), language = _a.language, setLanguage = _a.setLanguage, t = _a.t;
    var handleChange = function (event) {
        setLanguage(event.target.value);
    };
    return (_jsx(FormControl, { size: "small", variant: "outlined", sx: { minWidth: 120 }, children: _jsxs(Select, { value: language, onChange: handleChange, sx: {
                color: 'white',
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.8)' },
                '.MuiSvgIcon-root': { color: 'white' }
            }, children: [_jsxs(MenuItem, { value: "en", children: ["\uD83C\uDDFA\uD83C\uDDF8 ", t('english')] }), _jsxs(MenuItem, { value: "zh", children: ["\uD83C\uDDE8\uD83C\uDDF3 ", t('chinese')] })] }) }));
};
export default LanguageSelector;
